import { z } from 'zod'
import i18n from '@/lib/i18n'

export const loginSchema = z.object({
	registration: z.string().min(1, i18n.t('form.login.registrationError')),
	password: z.string().min(6, i18n.t('form.login.passwordError')),
})

export type LoginFormData = z.infer<typeof loginSchema>
